import { createApi } from "@reduxjs/toolkit/query/react";

import { triggerFileDownload } from "@/shared/helpers/trigger-file-download.helper";

import { ApiTags } from "../api-tags.enum";
import customFetchBase from "../custom-fetch-base";

import { fetchSampleFile } from "./functions";

import type {
  SampleDataKey,
  IDownloadSampleFileSuccessResult,
} from "./sample-data.interface";

const sampleDataApi = createApi({
  reducerPath: "sampleDataApi",
  baseQuery: customFetchBase,
  tagTypes: [ApiTags.SampleData],
  endpoints: (builder) => ({
    downloadSampleFile: builder.mutation<IDownloadSampleFileSuccessResult, SampleDataKey>({
      queryFn: async (key) => {
        const result = await fetchSampleFile(key);
        if (result.error) {
          return { error: { status: result.error.statusCode, data: result.error } };
        }
        triggerFileDownload(result.data!.blob, result.data!.filename);
        return {
          data: { success: true as const, filename: result.data!.filename },
        };
      },
    }),
  }),
});

export const { useDownloadSampleFileMutation } = sampleDataApi;
export default sampleDataApi;
